import { USER_ROLE } from './user/types';
import { authorizeUser } from './authorizeUser';
import { subPages } from 'src/views/Admin';

export const getAdminPages = (userRoles: USER_ROLE[]) =>
  subPages.filter(page => authorizeUser(userRoles, page.authorizedRoles));



// WEBPACK FOOTER //
// ./src/services/getAdminPages.ts